'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDanger$002dAlert$0024$0024anon$00248 from "./presto.-Danger-Alert$$anon$8.js";
import * as $j_presto$002etypes$0024$002dPlan$002dCode$0024 from "./presto.types$-Plan-Code$.js";
var $p;
/** @constructor */
function $c_Lpresto_DangerAlert$$anon$7() {
  this.aK1 = null;
  this.aJZ = null;
  this.aK0 = false;
  this.aJX = null;
  this.aJY = false;
  this.aK2 = false;
  this.aK3 = false;
  this.aK1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_DangerAlert$$anon$7 as $c_Lpresto_DangerAlert$$anon$7 };
$p = $c_Lpresto_DangerAlert$$anon$7.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DangerAlert$$anon$7;
/** @constructor */
function $h_Lpresto_DangerAlert$$anon$7() {
}
export { $h_Lpresto_DangerAlert$$anon$7 as $h_Lpresto_DangerAlert$$anon$7 };
$h_Lpresto_DangerAlert$$anon$7.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.aK1;
});
$p.t = (function() {
  if ((!this.aK0)) {
    this.aJZ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("features", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aK0 = true;
  }
  return this.aJZ;
});
$p.ad = (function() {
  if ((!this.aJY)) {
    this.aJX = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dPlan$002dCode$0024.$m_Lpresto_types$PlanCode$().cHB(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25(new $j_presto$002e$002dDanger$002dAlert$0024$0024anon$00248.$c_Lpresto_DangerAlert$$anon$8()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aJY = true;
  }
  return this.aJX;
});
$p.v = (function() {
  if ((!this.aK3)) {
    this.aK2 = false;
    this.aK3 = true;
  }
  return this.aK2;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_DangerAlert$$anon$7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DangerAlert$$anon$7, "presto.DangerAlert$$anon$7", ({
  GS: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_DangerAlert$$anon$7 as $d_Lpresto_DangerAlert$$anon$7 };
//# sourceMappingURL=presto.-Danger-Alert$$anon$7.js.map
